import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, Router } from '@angular/router';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { ClerkService } from 'ngx-clerk-iliad';
import { PLATFORM_ID, NgZone } from '@angular/core';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';
import { APP_VERSION } from './environments/build-info';
import { apiBaseUrlInterceptor } from './app/interceptors/api-base-url.interceptor';
import { authInterceptor } from './app/interceptors/auth.interceptor';
import { H } from 'highlight.run';

// Initialize console logging toggle based on environment.enableConsoleLogging
(function () {
  try {
    const enabled = (environment as any).enableConsoleLogging !== false;
    if (!enabled) {
      const noop = () => {};
      const c = console as any;
      c.log = noop;
      c.info = noop;
      c.debug = noop;
      c.warn = noop;
      c.table = noop;
      c.trace = noop;
    }
  } catch {}
})();

// High-visibility startup log to verify build and environment in production
try {
  (window as any).__WADDLE_BUILD__ = environment.buildNumber;
  console.log('[App Startup] WaddleNav starting', {
    buildNumber: environment.buildNumber,
    production: environment.production,
    apiUrl: environment.apiUrl
  });
} catch {}

// Initialize Highlight.run in all environments
try {
  const env = environment.production ? 'production' : 'development';
  const w = window as any;
  if (!w.__HIGHLIGHT_INITIALIZED__) {
    H.init('9memje21', {
      environment: env,
      // App Version (main) from package.json via build-info.ts
      version: APP_VERSION + String(environment.buildNumber ?? 'dev'),
      backendUrl: 'https://whoops.imok.space/public',
      otlpEndpoint: 'https://whoops.imok.space',
      tracingOrigins: true,
      storageMode: 'sessionStorage',
      manualStart: true,
      networkRecording: { enabled: true, recordHeadersAndBody: true },
      // debug: { clientInteractions: true, domRecording: true },

      // Enable Mapbox (WebGL/canvas) capture in Highlight session replay
      enableCanvasRecording: true,
      samplingStrategy: {
        canvas: 2,
        canvasMaxSnapshotDimension: 720
      }
    });

    H.start({ forceNew: true });
    w.__HIGHLIGHT_INITIALIZED__ = true;
  }
} catch (e) {
  console.warn('Highlight init failed:', e);
}

// Clerk initialization is handled centrally via ClerkService.__init in AppComponent

bootstrapApplication(AppComponent, {
  providers: [
    // Ensure base URL rewrite happens before auth header injection
    provideHttpClient(withInterceptors([
      apiBaseUrlInterceptor,
      authInterceptor
    ])),
    provideRouter(routes),
    provideIonicAngular(),
    {
      provide: ClerkService,
      useFactory: (platformId: Object, router: Router, ngZone: NgZone) =>
        new ClerkService(platformId, router, ngZone),
      deps: [PLATFORM_ID, Router, NgZone]
    }
  ]
}).catch(err => console.error(err));
